/**
 * This file exports constants that are used as enums in the
 *  crosstab group implementation.
 */
/**
 * Width of the crosstab.
 */
export const X = 'x';
/**
 * Width of the crosstab.
 */
export const Y = 'y';
/**
 * Width of the crosstab.
 */
export const WIDTH = 'width';

/**
 * Height of the crosstab.
 */
export const HEIGHT = 'height';

/**
 * Field referring to object storing measurement configuration.
 */
export const MEASUREMENT = 'measurement';

/**
 * Field referring to object storing configuration properties.
 */
export const CONFIG = 'config';

/**
 * Width of visual unit in crosstab.
 */
export const MIN_UNIT_WIDTH = 'minUnitWidth';

/**
 * Height of visual unit.
 */
export const MIN_UNIT_HEIGHT = 'minUnitHeight';

/**
 * Field to store the array of dimensions to facet by.
 */
export const DIMENSIONS = 'dimensions';

/**
 * Field to store array of measures to use as x axis.
 */
export const MEASURES = 'measures';

/**
 * Field to store the array of dimensions to facet by.
 */
export const DIMENSION = 'dimension';

/**
 * Field to store array of measures to use as x axis.
 */
export const MEASURE = 'measure';

/**
 * Flag to specify if model should be pivoted.
 */
export const PIVOT = 'pivot';

/**
 * Flag to specify format
 */
export const FORMAT = 'format';

/**
 * Mount point where the variable will be hosted
 */
export const MOUNT = 'mount';

/**
 * Data update flag
 */
export const HAS_DATA_UPDATED = 'hasDataUpdated';

/**
 * Field referring to object storing set of rows
 */
export const ROWS = 'rows';

/**
 * Field referring to object storing set of columns
 */
export const COLUMNS = 'columns';

/**
 * Field referring to object storing data
 */
export const DATA = 'data';

/**
 * Field referring to object storing set of columns
 */
export const COL = 'col';

/**
 * Field referring to object storing set of rows
 */
export const ROW = 'row';

/**
 * Field referring to object storing set of columns
 */
export const COLUMN = 'column';

/**
 * Field referring to object storing color field
 */
export const COLOR = 'color';

/**
 * Field referring to object storing shape field
 */
export const SHAPE = 'shape';

/**
 * Field referring to object storing size field
 */
export const SIZE = 'size';

/**
 * Field referring to object storing detail field
 */
export const DETAIL = 'detail';

/**
 * Field referring to object storing set of layers
 */
export const LAYERS = 'layers';

/**
 * Field referring to object storing the transforms
 */
export const TRANSFORM = 'transform';

/**
 * Field referring to object storing the transforms
 */
export const ORDINAL = 'ordinal';

/**
 * Field referring to object storing the transforms
 */
export const LINEAR = 'linear';
/**
 * Field referring to object storing the transforms
 */
export const LEFT = 'left';
/**
 * Field referring to object storing the transforms
 */
export const RIGHT = 'right';
/**
 * Field referring to object storing the transforms
 */
export const TOP = 'top';
/**
 * Field referring to object storing the transforms
 */
export const BOTTOM = 'bottom';

/**
 * Field referring to object storing the transforms
 */
export const RETINAL = 'retinal';
/**
 * Field referring to object storing the transforms
 */
export const CELL = 'cell';
/**
 * Field referring to object storing the transforms
 */
export const X_AXES = 'xAxes';
/**
 * Field referring to object storing the transforms
 */
export const Y_AXES = 'yAxes';
/**
 * Field referring to object storing the transforms
 */
export const ENTRY_CELLS = 'entryCell';
/**
 * Field referring to object storing the transforms
 */
export const INITIALIZED = 'initialized';
/**
 * Field referring to object storing the transforms
 */
export const EXIT_CELLS = 'exitCell';
/**
 * Field referring to object storing the transforms
 */
export const AXIS = 'axis';
/**
 * Field referring to object storing the transforms
 */
export const UNIT = 'unit';
/**
 * Field referring to object storing the transforms
 */
export const UPDATED = 'updated';
/**
 * Field referring to object storing the transforms
 */
export const BEFORE_UPDATE = 'beforeupdate';
/**
 * Field referring to object storing the transforms
 */
export const VALUE_MATRIX = 'valueMatrix';
/**
 * Field referring to object storing the transforms
 */
export const FACET_HEADERS = 'facet-headers';
/**
 * Field referring to object storing the transforms
 */
export const RADIUS = 'radius';
/**
 * Field referring to object storing the transforms
 */
export const ANGLE = 'angle';

export const ANGLE0 = 'angle0';
/**
 * Field referring to object storing the transforms
 */
export const ARC = 'arc';
/**
 * Field referring to object storing the transforms
 */
export const CATEGORICAL = 'categorical';
/**
 * Field referring to object storing the transforms
 */
export const TEMPORAL = 'temporal';
/**
 * Field referring to object storing the transforms
 */
export const BAR = 'bar';
/**
 * Field referring to object storing the transforms
 */
export const LINE = 'line';
/**
 * Field referring to object storing the transforms
 */
export const POINT = 'point';
/**
 * Field referring to object storing the transforms
 */
export const PRIMARY = 'Primary';
/**
 * Field referring to object storing the transforms
 */
export const SECONDARY = 'Secondary';
/**
 * Field referring to object storing the transforms
 */
export const BOTH = 'both';
/**
 * Field referring to object storing the transforms
 */
export const INTERACTION = 'interaction';
/**
 * Field referring to object storing the transforms
 */
export const GRID_LINES = 'gridLines';
/**
 * Field referring to object storing the transforms
 */
export const GRID_BANDS = 'gridBands';
/**
 * Field referring to object storing the transforms
 */
export const HEADER = 'header';
/**
 * Field referring to object storing the transforms
 */
export const FACET = 'facet';
export const DEFAULT = 'default';
/**
 * Ordering type
 */
export const ASCENDING = 'asc';
/**
 * Ordering type
 */
export const DESCENDING = 'desc';

export const DARK = 'dark';
export const NONE = 'none';
export const NORMAL = 'normal';
export const DARKER = 'darker';
